/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSavedPaymentMethodRequestType
 */
export interface GetSavedPaymentMethodRequestType {
}

/**
 * Check if a given object implements the GetSavedPaymentMethodRequestType interface.
 */
export function instanceOfGetSavedPaymentMethodRequestType(value: object): value is GetSavedPaymentMethodRequestType {
    return true;
}

export function GetSavedPaymentMethodRequestTypeFromJSON(json: any): GetSavedPaymentMethodRequestType {
    return GetSavedPaymentMethodRequestTypeFromJSONTyped(json, false);
}

export function GetSavedPaymentMethodRequestTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSavedPaymentMethodRequestType {
    return json;
}

export function GetSavedPaymentMethodRequestTypeToJSON(json: any): GetSavedPaymentMethodRequestType {
    return GetSavedPaymentMethodRequestTypeToJSONTyped(json, false);
}

export function GetSavedPaymentMethodRequestTypeToJSONTyped(value?: GetSavedPaymentMethodRequestType | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

